// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a00d9b35","885":"2ed84a15"}[chunkId] + ".chunk.js";
};